import Image from '../index'
import React from 'react'

export default props => <Image { ...props } width={ 180 } />
